// Server side filter for the invite list. Sent to jobseeker/invite-list as the
// `filter` query param. Mirrors the backend JobseekerInviteFilterEnum.
export enum JobseekerInviteFilterEnum {
    All = 1,
    New = 2,
    InterestedAndApplied = 3,
    Interested = 4,
    NotInterested = 5,
}
